import { Component } from '@angular/core';

@Component({
  selector: 'app-semnatari',
  templateUrl: './semnatari.component.html',
  styleUrls: ['./semnatari.component.scss']
})
export class SemnatariComponent {

}
